import { useHistory } from 'react-router'

import Flex from './utils/Flex'
import TWDropdown from './utils/TWDropdown'
import PhoriaLogo from '../assets/images/Phoria-Logo_YBBG.png'

const NotifyDropDown = ({ nav }) => {

	const history = useHistory()

	return (
		<TWDropdown contentClass="fixed 2xl:top-20 right-0" toggler={onClickToggler => (
			<button onClick={onClickToggler} className="relative">
				<i className="material-icons md:text-2xl lg:text-3xl 2xl:text-4xl">{nav.icon}</i>
				{nav.badge && (
					<span className="h-5 w-5 text-xs font-bold absolute top-0 -right-1 rounded-full bg-red-500 flex items-center justify-center">
						{nav.badge}
					</span>
				)}
			</button>
		)}>
			<div className="notify-dropdown flex flex-col space-y-2 md:space-y-4 mx-auto sm:mx-0 p-2 md:p-4 bg-secondary2 shadow-md">
				{[...Array(5).keys()].map(index => (
					<Flex
						key={index}
						items-center
						justify-between
						className="bg-primary py-2 md:py-4 pl-4 pr-8 md:px-12 space-x-4 rounded relative"
					>
						<img
							src={PhoriaLogo}
							alt="Phoria Logo"
							className="w-8 md:w-12 h-8 md:h-12 rounded-full flex-shrink-0"
						/>
						<h4 className="font-bold text-sm md:text-lg">
							<button onClick={() => history.push('/elharlen')} className=" text-blue-400">
								ElHarlen
							</button>
							has liked your post
						</h4>
						<span>🤑</span>
						<button className="absolute top-2 right-2 text-gray-300 hover:text-white">
							<i className="material-icons text-sm">close</i>
						</button>
					</Flex>
				))}
			</div>
		</TWDropdown>
	)
}

export default NotifyDropDown